/**
 * Javascript-Einstiegspunkt. Hier wird die Haupt-Vue-Komponente (App.vue)
 * in einer neuen Vue-Instanz und dem Router initialisiert.
 */

// // The Vue build version to load with the `import` command
import { createApp } from 'vue'

import { i18n } from "@/i18n/i18n";
import Router from '@/router/router'
import App from "@/App";
import BootstrapVue from "bootstrap-vue";
import "@/styles/style.scss";
import { brand } from "@/brand/brand";

document.getElementById("favicon").href=brand.favicon

const app = createApp(App)
app.use(Router)
app.use(BootstrapVue)
app.use(i18n)
app.mount('#app')
